import { PageResponse } from '@core/entities/pagination'
import {
  ILinkedProcessItemResult,
  LinkedProcessItemResult,
  LinkedProcesses,
} from '@core/entities/linkedProcesses'
import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { registerItemKeys } from '../registerItemKeys'
import { RequestTypes } from '../requestTypes'
import { RequestErrorType } from '@core/utils/api-axios-instance'

const dataTransformer = ({
  content,
}: PageResponse<ILinkedProcessItemResult>) => {
  return LinkedProcesses.new({
    linkedProcessItemResults: content,
  }).getLinkedTasks()
}

export const useGetRegisterItemTasks = (
  payload: RequestTypes['getRegisterItemTasks'],
  options: UseQueryOptions<
    PageResponse<ILinkedProcessItemResult>,
    RequestErrorType,
    Array<LinkedProcessItemResult>
  > = {},
) => {
  const query = registerItemKeys.byId(payload)._ctx.inspectionTasks(payload)

  return useQuery({
    select: dataTransformer,
    ...query,
    ...options,
  })
}
